import { useTranslation } from 'react-i18next';

import { useContent } from '../../hooks/useContent';

import type { RegisteredCompany } from '../../models/company';
import type { RichContentType, SearchPageProps } from '@insify/funnel-components';

export const useCompanyContent = (): Pick<SearchPageProps<RegisteredCompany>, 'translations'> & {
  richContent?: RichContentType;
} => {
  const { t } = useTranslation(['funnel', 'common']);
  const { quoteWizardCompany } = useContent() || {};
  return {
    richContent: quoteWizardCompany,
    translations: {
      searchLabel: t('funnel:company_input_label'),
      showMore: t('funnel:company_button_show_more'),
      searchPlaceholder: t('funnel:company_input_placeholder'),
    },
  };
};
